import PropTypes from 'prop-types';
import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import withBreakpoints from '@/hocs/withBreakpoints';
import {withBgNeutral900} from '@/hocs/withColors';
import {withMarginBottom2xl} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {H2Neutral50} from '@/typography';
import PictureWrapper from '@/ui/images-wrapper';

const DivMargined2xl = withMarginBottom2xl('div');
const SectionBgNeutral900 = withBgNeutral900(SectionPadding);

const propTypes = {
  variant: PropTypes.string
};

const PartnerLogos = withBreakpoints({
  desktop: ({imgPath}) => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="client-logos"
      imageTypeFallback="jpg"
      alt="Partner logos"
    />
  ),
  mobile: ({imgPath}) => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="client-logos-mobile"
      imageTypeFallback="jpg"
      alt="Partner logos"
    />
  )
});

const JoinOurNetworkSection = ({variant = 'main-page'}) => {
  const imgPath = `/static/images/partnership-program/${variant}/join-our-network/`;

  return (
    <SectionBgNeutral900>
      <Container>
        <Grid fluid>
          <DivMargined2xl>
            <Row center="xs">
              <Col xs={12} lg={7}>
                <H2Neutral50>Join our expanding network of partners</H2Neutral50>
              </Col>
            </Row>
          </DivMargined2xl>
          <Row center="xs">
            <Col>
              <PartnerLogos imgPath={imgPath} />
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionBgNeutral900>
  );
};

JoinOurNetworkSection.propTypes = propTypes;

export default JoinOurNetworkSection;
